<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('especies')">Especies</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Editar
    </h1>

    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            v-model="form.nombre"
            :error="form.errors.nombre"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nombre"
            required
          />

          <text-input
            v-model="form.tipo_manejo_reproductivo"
            :error="form.errors.tipo_manejo_reproductivo"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Tipo de manejo reproductivo"
          />

          <text-input
            v-model="form.descripcion"
            :error="form.errors.descripcion"
            class="pr-6 pb-8 w-full"
            label="Descripción"
          />
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            Actualizar Especie
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Editar Especie' },
  layout: Layout,
  components: { TextInput, LoadingButton },
  props: {
    especie: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nombre: this.especie.nombre || null,
        descripcion: this.especie.descripcion || null,
        tipo_manejo_reproductivo: this.especie.tipo_manejo_reproductivo || null,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('especies.update', { especie: this.especie.id }))
    },
  },
}
</script>